import React from "react";
import dayjs from "dayjs";
import { UsageData } from "../../../services/Usage";
import { PlatformData } from "../../../services/Platform";
import { formatCurrency } from "../../../utils/Currency";

interface UsageDataListProps {
  usageRecords: UsageData[];
  platforms: PlatformData[];
}

const UsageDataList: React.FC<UsageDataListProps> = ({
  usageRecords,
  platforms,
}) => {
  // Helper function to get platform name
  const getPlatformName = (platformId: string): string => {
    const platform = platforms.find((p) => p._id === platformId);
    return platform?.name || "Unknown Platform";
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full apple-card">
        <thead className="glass-card bg-gradient-to-r from-apple-gray-50 to-apple-gray-100 border-b">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-apple-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-apple-gray-500 uppercase tracking-wider">
              Platform
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-apple-gray-500 uppercase tracking-wider">
              Items
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-apple-gray-500 uppercase tracking-wider">
              Total Cost
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-apple-gray-500 uppercase tracking-wider">
              Created
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-apple-gray-200">
          {usageRecords.map((record) => (
            <tr
              key={record._id}
              className="hover:glass-card hover:bg-gradient-to-r from-apple-gray-50 to-apple-gray-100 hover-lift animate-slide-up"
            >
              <td className="px-6 py-4 whitespace-nowrap text-sm text-apple-gray-900">
                {dayjs(record.date).format("MMM D, YYYY")}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-apple-gray-900">
                {record.platform_name || getPlatformName(record.platform_id)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-apple-gray-900">
                {record.usage_items.length}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-apple-gray-900">
                {formatCurrency(record.total_cost || 0, {
                  useSimpleFormat: true,
                })}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-apple-gray-500">
                {record.createdAt
                  ? dayjs(record.createdAt).format("MMM D, YYYY")
                  : "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsageDataList;
